import { Box, Skeleton } from "@mui/material";

type ChatWaitingSessionProps = {
}
const ChatWaitingSession: React.FC<ChatWaitingSessionProps> = ({ }) => {
    return (
        <Box display="flex" flexDirection="column" gap={0.5}>
            {Array.from({ length: 2 }).map((_, index) => (
                <Box
                    key={index}
                    display="flex"
                    justifyContent={index % 2 === 0 ? "flex-start" : "flex-end"}
                >
                    <Skeleton variant="rounded" width="100%" height={68} sx={{ '&.MuiSkeleton-root': { borderRadius: '0px' } }} />
                </Box>
            ))}
        </Box>
    )
};

export default ChatWaitingSession;